import React from 'react'
import { useState } from 'react';

import { logo, close,menu } from '../assets';
import { navLinks } from '../constants/texts';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <nav>
      <div className="w-full py-5 flex justify-between items-start bg-b h-40">
        <img className='bg-y w-[28px] h-[28px] rounded-xl mx-5 my-2' src={logo} alt="conference" />

        <div className=" bg-b font-mono flex justify-center items-center text-y w-[150px] h-[40px] border-2 rounded-xl " >Tech Conference</div>
        <ul className="list-none sm:flex hidden justify-end item-center flex-1 pr-5">
        {navLinks.map((nav, index) => (
              <li
                key={nav.id}
                className={`font-poppins font-medium cursor-pointer text-[16px] text-y ${index === navLinks.length - 1 ? "mr-0" : "mr-10"}`}>
                <a href={`#${nav.id}`}>{nav.title}</a>
              </li>
            ))}
        </ul>
        <div className="sm:hidden flex flex-1 justify-end items-center px-5">
          <img src={toggle ? close : menu} alt="menu" className="w-[28px] h-[28px] object-contain" onClick={() => setToggle((prev)=> !prev)}/>
          <div className =  {` ${toggle ? 'flex' : 'hidden'} p-5 bg-gradient-to-bl from-blue via-blue2 to-b absolute top-12 right-0 mx-4 my-2 min-w-[120px] rounded-xl sidebar ` }>
            <ul className="list-none flex-col justify-end items-center flex-1">
            {navLinks.map((nav, index) => (
                <li
                  key={nav.id}
                  className={`font-mono font-medium cursor-pointer 
                              text-[16px] mr-5 text-y ${index === navLinks.length - 1 ? "mb-0" : "mb-4"}`}>
                  <a href={`#${nav.id}`}>{nav.title}</a>
                </li>
              ))}
            </ul>

          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar